// extracted by mini-css-extract-plugin
export var minPadding = "section-module--minPadding--09879";
export var section = "section-module--section--446f4";